/* Pause control for the background video, and an automatic pause under
   reduced-motion so the hero is not a moving picture nobody asked for. */
(() => {
  const init = (root) => {
    if (root.dataset.hvReady) return;
    root.dataset.hvReady = 'true';

    const video = root.querySelector('video');
    const button = root.querySelector('[data-hv-pause]');
    if (!video) return;

    const paused = () => root.hasAttribute('data-paused');

    const stop = () => {
      video.pause();
      root.setAttribute('data-paused', '');
    };

    const start = () => {
      const played = video.play();
      if (played && typeof played.catch === 'function') played.catch(() => {});
      root.removeAttribute('data-paused');
    };

    /* Data saver and a metered connection are explicit "don't" signals; a 1080p
       loop is the most expensive thing on the page and the poster carries it. */
    const link = navigator.connection;
    const cheap =
      !!link && (link.saveData === true || /^([23]g|slow-2g)$/.test(link.effectiveType || ''));

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const manual = !video.hasAttribute('autoplay');
    if (reduced || cheap) {
      video.removeAttribute('autoplay');
      video.preload = 'none';
    }
    if (reduced || cheap || manual) stop();

    // A pause the visitor asked for outlives scrolling past and back.
    let byHand = reduced || cheap || manual;

    button?.addEventListener('click', () => {
      byHand = !paused();
      byHand ? stop() : start();
    });

    /* Decoding a full-screen loop nobody can see costs a core on a slow
       machine, and the page is many screens tall. Off screen, off. */
    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (byHand) return;
          entry.isIntersecting ? start() : stop();
        });
      },
      { threshold: 0.01 }
    ).observe(video);

    // A tab switch or an external pause should be reflected on the button.
    video.addEventListener('pause', () => root.setAttribute('data-paused', ''));
    video.addEventListener('play', () => root.removeAttribute('data-paused'));
  };

  const scan = (scope) => scope.querySelectorAll('[data-hv]').forEach(init);

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
